import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import _ from 'lodash';
import { useAuthentication, LocalizeProviderWrapper, useWindowSizeContext } from '@tradingblock/components';
import { Login } from './Login';
import { ForgotPassword } from './ForgotPassword';
import { ApiServerConfigurationContext } from './ApiServerConfigurationContext';
import { ResetPasswordConfirmation } from './ResetPasswordConfirmation';
import UpdatedAgreements from './UpdatedAgreements';
import { EmailVerification } from './EmailVerification';
import ReactGA from 'react-ga4';
import { config } from '../clientConfig';
import { TradingBlockEnvironments } from '@tradingblock/types';
import { MarketDataQuestionnaire } from './MarketDataQuestionnaire';
import { MobileMarketDataQuestionnaire } from './MobileMarketDataQuestionnaire';
import { VTHomePage } from './VTHomePage';
import TwoFactorAuthenticationSetupWrapper from './TwoFactorAuthenticationSetupWrapper';

const TRACKING_ID =
  config.environment === TradingBlockEnvironments.dashboard
    ? config.dashboard.ga4TrackingCode
    : config.virtual.ga4TrackingCode;
if (TRACKING_ID) {
  ReactGA.initialize(TRACKING_ID);
}

const App = ({ defaultRedirect }: { defaultRedirect: string }) => {
  const [renderMobileMarketDataQuestionnaireRoute, setRenderMobileMarketDataQuestionnaireRoute] = useState<boolean>(
    false
  );

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);

    setRenderMobileMarketDataQuestionnaireRoute(!!(window && window.ReactNativeWebView));
  }, []);

  const isVirtual = config.environment === TradingBlockEnvironments.virtual;

  return (
    <useAuthentication.Provider>
      <ApiServerConfigurationContext.Provider value={{ defaultRedirectUrl: defaultRedirect }}>
        <LocalizeProviderWrapper>
          <useWindowSizeContext.Provider>
            <Switch>
              <Route path="/email-verification/:token" component={EmailVerification} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route path="/reset-password/:token" component={ResetPasswordConfirmation} />
              <Route path="/updated-agreements" component={UpdatedAgreements} />
              <Route path="/two-factor-authentication-setup" component={TwoFactorAuthenticationSetupWrapper} />
              <Route path="/market-data-questionnaire" component={MarketDataQuestionnaire} />
              {renderMobileMarketDataQuestionnaireRoute && (
                <Route exact path="/mobile/market-data-questionnaire" component={MobileMarketDataQuestionnaire} />
              )}
              {isVirtual ? (
                // Virtual Trading routes
                <>
                  <Route exact path="/login" component={Login} />
                  <Route exact path="/" component={VTHomePage} />
                </>
              ) : (
                // Regular routes
                <Route path="/" component={Login} />
              )}
            </Switch>
          </useWindowSizeContext.Provider>
        </LocalizeProviderWrapper>
      </ApiServerConfigurationContext.Provider>
    </useAuthentication.Provider>
  );
};

export default App;
